import moment from 'moment'

Function.prototype.property = function(prop, desc) {
  if (desc.enumerable == null) {
    desc.enumerable = true
  }
  if (desc.configurable == null) {
    desc.configurable = true
  }
  return Object.defineProperty(this.prototype, prop, desc)
}

export function dateToISO(date, format) {
  return moment(date, format).format('YYYY-MM-DD')
}

export function classInstanceToObject(instance) {
  const newOject = {}
  Object.entries(instance).forEach(([key, value]) => {
    if (key === 'toObject' || key === 'constructor') return
    newOject[key] = value
  })
  return newOject
}
